export default "__VITE_ASSET__DUlEsBey__"